var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.768 68.0139C132.588 68.0139 135.722 64.9087 135.332 61.1082C134.209 50.1647 130.431 39.6225 124.281 30.4178C116.845 19.2894 106.276 10.6158 93.9107 5.49393C81.5454 0.372064 67.939 -0.96805 54.8121 1.64306C41.6851 4.25416 29.6273 10.6992 20.1633 20.1632C10.6993 29.6272 4.25428 41.685 1.64318 54.8119C-0.967928 67.9389 0.372186 81.5453 5.49405 93.9105C10.6159 106.276 19.2895 116.845 30.418 124.28C39.6226 130.431 50.1648 134.209 61.1083 135.332C64.9088 135.722 68.014 132.588 68.014 128.768C68.014 124.947 64.9044 121.896 61.1154 121.406C52.9131 120.346 45.0325 117.406 38.1043 112.777C29.251 106.861 22.3507 98.4534 18.2759 88.6161C14.2012 78.7788 13.1351 67.9542 15.2124 57.511C17.2896 47.0678 22.417 37.4751 29.9462 29.946C37.4753 22.4169 47.0679 17.2895 57.5111 15.2122C67.9543 13.135 78.779 14.2011 88.6162 18.2758C98.4535 22.3506 106.862 29.2509 112.777 38.1042C117.406 45.0323 120.347 52.913 121.406 61.1153C121.896 64.9043 124.947 68.0139 128.768 68.0139Z",
    fill: "#102365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.10460108d67e1b9b2d09d31fc9fcb2b3.svg";
export { ForwardRef as ReactComponent };